export default __webpack_public_path__ + "static/media/007-martini.da524697.svg";